import { render, staticRenderFns } from "./ResearchGeneLinks.vue?vue&type=template&id=b1aca0de&"
import script from "./ResearchGeneLinks.vue?vue&type=script&lang=js&"
export * from "./ResearchGeneLinks.vue?vue&type=script&lang=js&"
import style0 from "./ResearchGeneLinks.vue?vue&type=style&index=0&id=b1aca0de&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1aca0de')) {
      api.createRecord('b1aca0de', component.options)
    } else {
      api.reload('b1aca0de', component.options)
    }
    module.hot.accept("./ResearchGeneLinks.vue?vue&type=template&id=b1aca0de&", function () {
      api.rerender('b1aca0de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchGeneLinks.vue"
export default component.exports